import { lineHeightForSize, remForSize } from '../../../utils';
/* eslint-disable sort-keys */ const baseTextStyles = {
    xs: {
        fontSize: 'xs',
        fontFamily: 'body',
        fontWeight: 'regular',
        lineHeight: lineHeightForSize('xs'),
        letterSpacing: 'normal'
    },
    s: {
        fontSize: 's',
        fontFamily: 'body',
        fontWeight: 'regular',
        lineHeight: lineHeightForSize('s'),
        letterSpacing: 'normal'
    },
    m: {
        fontSize: 'm',
        fontFamily: 'body',
        fontWeight: 'regular',
        lineHeight: lineHeightForSize('m'),
        letterSpacing: 'normal'
    },
    l: {
        fontSize: 'l',
        fontFamily: 'body',
        fontWeight: 'regular',
        lineHeight: lineHeightForSize('l'),
        letterSpacing: 'normal'
    },
    xl: {
        fontSize: 'xl',
        fontFamily: 'body',
        fontWeight: 'regular',
        lineHeight: lineHeightForSize('xl'),
        letterSpacing: 'normal'
    },
    '2xl': {
        fontSize: '2xl',
        fontFamily: 'heading',
        fontWeight: 'semibold',
        lineHeight: lineHeightForSize('2xl'),
        letterSpacing: 'normal'
    },
    '3xl': {
        fontSize: '3xl',
        fontFamily: 'heading',
        fontWeight: 'semibold',
        lineHeight: lineHeightForSize('3xl'),
        letterSpacing: 'normal'
    },
    '4xl': {
        fontSize: '4xl',
        fontFamily: 'heading',
        fontWeight: 'semibold',
        lineHeight: lineHeightForSize('4xl'),
        letterSpacing: 'normal'
    },
    '5xl': {
        fontSize: '5xl',
        fontFamily: 'heading',
        fontWeight: 'semibold',
        lineHeight: lineHeightForSize('5xl'),
        letterSpacing: 'normal'
    },
    '6xl': {
        fontSize: '6xl',
        fontFamily: 'heading',
        fontWeight: 'semibold',
        lineHeight: lineHeightForSize('6xl'),
        letterSpacing: 'normal'
    },
    '7xl': {
        fontSize: '7xl',
        fontFamily: 'heading',
        fontWeight: 'semibold',
        lineHeight: lineHeightForSize('7xl'),
        letterSpacing: 'normal'
    }
};
export default {
    fonts: {
        body: 'Poppins, sans-serif',
        heading: 'Poppins, sans-serif',
        mono: 'monospace'
    },
    fontSizes: {
        xs: remForSize('xs'),
        s: remForSize('s'),
        m: remForSize('m'),
        l: remForSize('l'),
        xl: remForSize('xl'),
        '2xl': remForSize('2xl'),
        '3xl': remForSize('3xl'),
        '4xl': remForSize('4xl'),
        '5xl': remForSize('5xl'),
        '6xl': remForSize('6xl'),
        '7xl': remForSize('7xl')
    },
    fontWeights: {
        regular: 400,
        semibold: 600,
        extrabold: 800
    },
    letterSpacings: {
        tighter: '-0.05em',
        tight: '-0.025em',
        normal: '0',
        wide: '0.025em',
        wider: '0.05em',
        widest: '0.1em'
    },
    textStyles: {
        ...baseTextStyles,
        xsCaps: {
            ...baseTextStyles.xs,
            textTransform: 'uppercase'
        },
        xsBold: {
            ...baseTextStyles.xs,
            fontWeight: 'semibold'
        },
        sCaps: {
            ...baseTextStyles.s,
            textTransform: 'uppercase'
        },
        sBold: {
            ...baseTextStyles.s,
            fontWeight: 'semibold'
        },
        mBold: {
            ...baseTextStyles.m,
            fontWeight: 'semibold'
        },
        lBold: {
            ...baseTextStyles.l,
            fontWeight: 'semibold'
        },
        xlBold: {
            ...baseTextStyles.xl,
            fontWeight: 'semibold'
        },
        bold: {
            fontWeight: 'semibold'
        }
    }
}; /* eslint-enable sort-keys */ 

//# sourceMappingURL=typography.js.map